module.exports = __webpack_public_path__ + "assets/img/e26a-mo.svg";